import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import {
  onDeselectAlbum as onDeselectAlbumAction,
  onResetIdentity as onResetIdentityAction,
} from '../../actions/discover-album-folder';
import {
  openModal as openModalAction,
  closeModal as closeModalAction,
} from '../../actions/modal-actions';
import DiscoverAlbumFolderAlbumSelectionModal from '../../components/discover/DiscoverAlbumFolderAlbumSelectionModal';
import { DISCOVER_IDENTITY_SELECTED_ALBUMS } from '../../constants/modals';
import IdentityNavModal from '../../components/discover/IdentityNavModal';
import { isAlbumFolderTagSelectionRequiredForCheckout } from '../../util/album-folder';

class DiscoverAlbumFolderAlbumSelectionModalContainer extends Component {
  static propTypes = {
    identities: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        selectedAlbums: PropTypes.array,
      }),
    ),
    onClose: PropTypes.func,
    selectedIdentity: PropTypes.shape({
      id: PropTypes.string,
    }),
    onResetIdentity: PropTypes.func,
    onDeselectAlbum: PropTypes.func,
    openModal: PropTypes.func,
    albumFolder: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }).isRequired,
    closeModal: PropTypes.func,
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  static defaultProps = {
    includeIdentityNavModal: false,
  };

  componentDidUpdate(prevProps) {
    const { selectedIdentity, openModal } = this.props;

    if (
      selectedIdentity &&
      prevProps.selectedIdentity.id !== selectedIdentity.id
    ) {
      openModal(DISCOVER_IDENTITY_SELECTED_ALBUMS);
    }
  }

  switchIdentity = () => {
    const { albumFolder, history, onResetIdentity } = this.props;

    onResetIdentity();
    history.push(`/discover/album-folder/${albumFolder.id}/faces`);
  };

  onCompleteEnrollment = () => {
    const { albumFolder, history } = this.props;

    // #youthSports
    if (isAlbumFolderTagSelectionRequiredForCheckout(albumFolder)) {
      history.push(`/purchase/album-folder/${albumFolder.id}/activities`);
      return;
    }

    history.push(`/discover/album-folder/${albumFolder.id}/summary`);
  };

  render() {
    const {
      onClose,
      onDeselectAlbum,
      identities,
      selectedIdentity,
      albumFolder,
      openModal,
      closeModal,
    } = this.props;

    const identity = identities.find(
      identityItem => identityItem.id === selectedIdentity.id,
    );

    if (!identity) {
      return null;
    }

    return (
      <Fragment>
        <DiscoverAlbumFolderAlbumSelectionModal
          onClose={onClose}
          onDeselectAlbum={onDeselectAlbum}
          identity={identity}
          albumFolder={albumFolder}
          openModal={openModal}
        />
        <IdentityNavModal
          identity={identity}
          albumFolder={albumFolder}
          switchIdentity={this.switchIdentity}
          albumFolderId={albumFolder.id}
          closeModal={closeModal}
          onCompleteEnrollment={this.onCompleteEnrollment}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  identities: discoverAlbumFolder.identities,
  albumFolderId: discoverAlbumFolder.albumFolderId,
});

const mapDispatchToProps = dispatch => ({
  onDeselectAlbum: (album, identityId) =>
    dispatch(onDeselectAlbumAction(album, identityId)),
  onResetIdentity: () => dispatch(onResetIdentityAction()),
  openModal: name => dispatch(openModalAction(name)),
  closeModal: name => dispatch(closeModalAction(name)),
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(DiscoverAlbumFolderAlbumSelectionModalContainer);
